var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20pt",
    viewBox: "0 0 64 64",
    width: "64pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 1C12.8 3.7 3.4 13.3 1 21.8-.5 27.3-.2 38 1.6 43.3 4.5 52 16.5 62.6 22.3 61.8c1.7-.2 2.3-1.1 2.5-3.5.3-2.9 0-3.3-2-3.3-4.6 0-6.9-1.3-9.8-5.6-3.4-5-2.6-5.8 1.3-1.4 2.1 2.4 3.5 3 6.6 3 2.8 0 4-.5 4.5-1.7.3-1 .9-2.4 1.2-3.1.4-.7-.2-1.2-1.6-1.2-1.1 0-3.8-.9-5.9-2-6.1-3-8.9-12.2-5.6-18 .8-1.4 1.4-4.4 1.5-6.8 0-4.5 1.2-5.2 5.3-3 1.2.6 6.4 1.1 11.7 1.1s10.5-.5 11.7-1.1c4.1-2.2 5.3-1.5 5.3 3 .1 2.4.7 5.4 1.5 6.8 3.3 5.8.5 15-5.6 18-2.1 1.1-4.7 2-5.9 2-2.1 0-2.6 1-1.1 2.6.6.5 1.1 3.8 1.3 7.4.3 5.8.5 6.5 2.5 6.8 6 .9 17.9-9.9 20.8-18.9 2.4-7 1.7-19.8-1.3-25.6C57.9 11 53.8 6.8 47.8 3.5 43.2 1 41.3.5 33.5.3 28.6.2 23.1.5 21.4 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.7be44278f05e0cb28691ae5d3cced257.svg";
export { ForwardRef as ReactComponent };